import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import {
  InMemoryScrollingFeature,
  InMemoryScrollingOptions,
  provideRouter,
  withInMemoryScrolling,
} from '@angular/router';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { RECAPTCHA_LOADER_OPTIONS } from 'ng-recaptcha-2';

import { routes } from './app.routes';
import { CookieService } from 'ngx-cookie-service';
import { authInterceptor } from './features/auth/services/auth-interceptor.service';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig);

const RECAPTCHA_LANGUAGE_MAP: Record<string, string> = {
  'es': 'es',
  'en': 'en',
  'fr': 'fr',
  'pt': 'pt',
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, inMemoryScrollingFeature),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(CookieService, BrowserAnimationsModule),
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useFactory: (locale: string) => ({
        onBeforeLoad(url: URL) {
          const language = RECAPTCHA_LANGUAGE_MAP[locale] || 'es';
          url.searchParams.set('hl', language);
          return { url };
        },
      }),
      deps: [LOCALE_ID],
    },
  ],
};
